import type { Core } from '@pdftron/webviewer';
import { devError, getSessionKey } from '../utils';
import { PdfViewerViewModeFlag } from './Enums';
import { ReduxUpdater } from './ReduxUpdater';
import { ApryseSDK } from './ApryseSDK';
import { parseXFDFDoc, serializeXFDFDoc } from '../utils/xfdfUtils';

export class RedliningActionLogger {
    static initialLogDone = false;

    static async appendLog(
        action: string,
        annotations?: Core.Annotations.Annotation[],
    ): Promise<void> {
        const sessionId = getSessionKey();

        if (ReduxUpdater.viewMode !== PdfViewerViewModeFlag.Annotation || !sessionId) {
            return Promise.resolve();
        }

        try {
            let xfdf = action === 'annotation-tab' ? undefined : await ApryseSDK.getAnnotationsXFDF();

            if (xfdf) {
                const { xfdfDoc, xfdfAnnots } = parseXFDFDoc(xfdf);
                xfdfAnnots.forEach(xfdfAnnot => {
                    if (xfdfAnnot.type === 'link' || !xfdfAnnot.isFromSession(ApryseSDK._startTime)) {
                        xfdfAnnot.delete();
                    }
                });
                xfdf = serializeXFDFDoc(xfdfDoc);
            }

            const actionInfo = {
                type: action,
                timestamp: Date.now(),
            };

            if (annotations) {
                actionInfo['annotations'] = annotations.map(ApryseSDK.getAnnotationBasicInfo);
            }

            const formData = new FormData();
            formData.append('sessionId', sessionId);
            formData.append('action', JSON.stringify(actionInfo));
            xfdf && formData.append('xfdf', xfdf);

            const response = await fetch('api/log/redlinings', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server responded with code [${response.status}]`);
            }

            return Promise.resolve();
        } catch (error) {
            devError(error as Error);
            return Promise.reject(
                new Error(`Error occurred during logging redlining action: "${error}"`),
            );
        }
    }
}
